import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idLead: string | undefined;
}

interface DataResponse {
  quantidadeTarefaEmAberto: number;
  quantidadeTarefaConcluidas: number;
  quantidadeTarefasAtrasadas: number;
}

export function useLeadQuantidade(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const QUANTIDADES = `${leadsWebEnviroment}/common/tarefas-leads/lead-quantidade/v1/${props.idLead}`;
    const response = await instance.get(QUANTIDADES);
    return response?.data?.data as DataResponse;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar aaaaa. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
